export default "/kiban/_next/static/images/bottom_white-08290143eab74cd96eff6e4716e3b047.png";